import { GetStorageParams } from "./storage.types";
import { GetStorageInvoicesParams } from "./storage.api";

export const STORAGE_KEYS = {
  STORAGE: "STORAGE",
  GET_STORAGES: (params?: GetStorageParams) => [`${STORAGE_KEYS.STORAGE}/getStorages`, params],
  all: ["storage"] as const,
  settings: () => [...STORAGE_KEYS.all, "settings"] as const,
  clientSettings: (clientId: string) => [...STORAGE_KEYS.settings(), clientId] as const,
  calculations: () => [...STORAGE_KEYS.all, "calculations"] as const,
  calculationsList: (filters: {
    clientId?: string;
    year?: number;
    month?: number;
  }) => [...STORAGE_KEYS.calculations(), filters] as const,
  jobs: () => [...STORAGE_KEYS.all, "jobs"] as const,
  jobsStatus: () => [...STORAGE_KEYS.jobs(), "status"] as const,
  // Storage Invoices
  invoices: () => [...STORAGE_KEYS.all, "invoices"] as const,
  invoicesList: (params: GetStorageInvoicesParams) => [...STORAGE_KEYS.invoices(), "list", params] as const,
  invoiceDetail: (id: string) => [...STORAGE_KEYS.invoices(), "detail", id] as const,
};
